import React, { useEffect } from "react";
import {
  SidebarContainer,
  CloseIcon,
  Icon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SidebarLinkR,
} from "./SidebarElements";

const Sidebar = ({ isOpen, toggle }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [isOpen]);
  return (
    <>
      <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
          <CloseIcon />
        </Icon>
        <SidebarWrapper>
          <SidebarMenu>
            <SidebarLink to="about" onClick={toggle}>
              Despre noi
            </SidebarLink>
            <SidebarLink to="mission" onClick={toggle}>
              Misiune
            </SidebarLink>
            <SidebarLink to="groups" onClick={toggle}>
              Grupe
            </SidebarLink>
            <SidebarLink to="vision" onClick={toggle}>
              Viziune
            </SidebarLink>
            <SidebarLink to="offer" onClick={toggle}>
              Oferta
            </SidebarLink>
            <SidebarLinkR to="/galerie" onClick={toggle}>
              Galerie
            </SidebarLinkR>
          </SidebarMenu>
        </SidebarWrapper>
      </SidebarContainer>
    </>
  );
};

export default Sidebar;
